module.exports = __webpack_public_path__ + "static/media/tenantinfo.2ffd4fc2.png";